module.exports = __webpack_public_path__ + "img/zcffxf.b2f10b3d.png";